import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import bin from "../assets/images/bin.png";
import { apiCall } from "../services/AxiosService";
import { API_URL } from "../services/APIRoute";
import { apiResponse } from "../services/APIResponse";
import { Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import SubmitLoading from "../component/common-component/Loaders/SubmitLoading";
import MainpageLoader from "../component/common-component/Loaders/MainpageLoader";

function FlowSaveConfirmPopup(props) {
  const [Loading, setLoading] = useState(false);

  const navigate = useNavigate();

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      className={"delete-modal"}
    >
      {Loading && <MainpageLoader />}
      <Modal.Body>
        <div className="text-center">
          <img src={bin} alt="bin" className="modal-delete-icon" />
          <h4>You have some changes in workflow which might not be saved.</h4>
          <p>Please confirm if you wish to proceed without saving.</p>
          <div className="d-flex align-items-center gap-2">
            <button className="grey-btn" onClick={props.onHide}>
              No, Keep Changes
            </button>
            <button className="red-btn" onClick={() => navigate("/workflows")}>
              {Loading ? <SubmitLoading /> : " Yes, Discard"}
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default FlowSaveConfirmPopup;
